import {Injectable} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgAppControllerConfig} from '../misc/classes/ExgAppControllerConfig';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IMessageRepositoryData} from '../misc/interfaces/IMessageRepositoryData';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ExgModalService} from 'exc-controls-v2';


@Injectable({
  providedIn: 'root'
})
export class SettingsDataService extends ExcTranslation {

  Global = {
    GetSummary: (): Observable<any> => {
      return this.excRest.get(this.excRest.computeUrl('GlobalSettingsR_Summary')).pipe(map(response => {
        if (response && response.success) {
          this.modal.showToast('Globale Einstellungen geladen', 'md-toast', 'fal fa-check');
        }
        return response;
      }));
    },
    Update: (globalObject: any): Observable<any> => {
      return this.excRest.sput(this.excRest.computeUrl('GlobalSettingsU'), globalObject, 'globalsettingsupdate')
        .pipe(map(response => {
          if (response && response.success) {
            this.modal.showToast('Globale Einstellungen gespeichert', 'md-toast', 'fal fa-check');
          }
          return response;
        }));
    },
  };

  AutoText = {
    GetList: (mode: string, type: number, oeID: string = '00000000-0000-0000-0000-000000000000'): Observable<any> => {
      return this.excRest.sget(this.excRest.computeUrl('TextbausteinR_List', {
        mode: mode,
        tb_enmIdent_Typ: type,
        tb_oeID: oeID
      }), mode + 'settingsload').pipe(map(response => {
        if (response && response.success) {
          this.modal.showToast('Mail Textvorlagen geladen', 'md-toast', 'fal fa-check');
        }
        return response;
      }));
    },
    Update: (id: string, tbObject: any): Observable<any> => {
      return this.excRest.sput(this.excRest.computeUrl('TextbausteinU', {
        tbID: id
      }), tbObject, id + 'settingsupdate').pipe(map(response => {
        if (response && response.success) {
          this.modal.showToast('Mail Textvorlage gespeichert', 'md-toast', 'fal fa-check');
        }
        return response;
      }));
    },
    Create: (mode: string, tbObject: any): Observable<any> => {
      return this.excRest.post(this.excRest.computeUrl('TextbausteinC', {
        mode: mode
      }), tbObject).pipe(map(response => {
        if (response && response.success) {
          this.modal.showToast('Mail Textvorlage erstellt', 'md-toast', 'fal fa-check');
        }
        return response;
      }));
    }
  };


  constructor(private excRest: ExcRestService, private modal: ExgModalService) {
    super();
  }
}

